module.exports = __webpack_public_path__ + "img/allergies-colored.c553341d.svg";